import axios from "axios";
// import { showMessage } from "../utils/uti";

// 设置超时时间
axios.defaults.timeout = 600000;
// 设置基本路径

axios.defaults.baseURL = "https://relayapp-store.polysmartchain.com/";
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.error(error);
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export { axios };
